// import { Button, Card, Col, Input, message, Row } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import styled from 'styled-components';
import ModalComponent from '../../components/ModalComponent';
import { baseUrl } from '../../constants/environment';
import { CommonStatus, Role } from '../../enums/common.enum';

import APIClient from '../../helpers/APIClient';
import { useUser } from '../../hooks/useUser';
import UserManager from '../../manager/UserManager';
import PageTitle from '../../components/PageTitle';
import { Card, CardBody } from 'reactstrap';
import { Tabs, message } from 'antd';
import InfoComponent from './components/InfoComponent';
import ChangePassComponent from './components/ChangePassComponent';
import PageBody from '../../components/PageBody';

const UserInfo = () => {
  const user = useUser();
  const [visible, setVisible] = useState(false);
  const { TabPane } = Tabs;

  return (
    <>
      <PageTitle title="Thông tin tài khoản" breadCrumbItems={[{ label: "Thông tin tài khoản", active: true }]} />
      <PageBody>
        <Tabs className='tab__info' defaultActiveKey={'info'}>
          <TabPane tab="Thông tin cá nhân" key="info">
            <InfoComponent />
          </TabPane>
          <TabPane tab="Đổi mật khẩu" key="changepass">
            <ChangePassComponent />
          </TabPane>
        </Tabs>
      </PageBody>
    </>
  );
};


export default UserInfo;
